import type { ClintplayEvent } from '../types';

type EventCallback = (event: ClintplayEvent) => void;

export class ResourceTracker {
  private handler: ((event: Event) => void) | null = null;

  constructor(
    private sessionId: string,
    private emit: EventCallback
  ) {}

  start(): void {
    this.handler = (event: Event) => {
      const target = event.target;
      if (!target || !(target instanceof HTMLElement)) return;

      let src: string | undefined;
      let tagDescription: string | undefined;

      if (target instanceof HTMLScriptElement) {
        src = target.src;
        tagDescription = `<script src="${src}">`;
      } else if (target instanceof HTMLLinkElement) {
        src = target.href;
        tagDescription = `<link href="${src}">`;
      } else if (target instanceof HTMLImageElement) {
        src = target.src;
        tagDescription = `<img src="${src}">`;
      } else {
        return;
      }

      this.emit({
        type: 'error',
        timestamp: Date.now(),
        sessionId: this.sessionId,
        data: {
          message: `Resource failed to load: ${tagDescription}`,
          type: 'onerror',
          source: src,
        },
      });
    };

    window.addEventListener('error', this.handler, true);
  }

  stop(): void {
    if (this.handler) {
      window.removeEventListener('error', this.handler, true);
      this.handler = null;
    }
  }
}
